import { useCallback, useMemo } from 'react';
import { isValid } from 'date-fns';
import { isValidDate } from '@aldebaran/common/util/date';
import { TimePicker } from '@/components/ui/timepicker';
import { ViewableQuestion } from '@/types/global';

interface ResponseTimeFieldProps {
  value?: number | Date;
  label?: string;
  questionLabel?: ViewableQuestion['label'];
  onChange: (value: number | null) => void;
  disabled?: boolean;
  isError?: boolean;
  showNow?: boolean;
}

export const ResponseTimeField = ({
  value,
  label,
  questionLabel,
  onChange,
  disabled,
  isError,
  showNow,
}: ResponseTimeFieldProps) => {
  const selected = useMemo(() => {
    if (!isValidDate(value)) return null;
    return value instanceof Date ? value : new Date(value as number);
  }, [value]);

  const onSubmitResponse = useCallback(
    (nextValue: Date | undefined) => {
      onChange(nextValue && isValid(nextValue) ? nextValue.getTime() : null);
    },
    [onChange],
  );

  return (
    <div className="w-full">
      <TimePicker
        value={selected}
        title={questionLabel || label || undefined}
        description={
          questionLabel && label && label !== questionLabel ? label : undefined
        }
        onChange={onSubmitResponse}
        disabled={disabled}
        isError={isError}
        showNow={showNow}
      />
    </div>
  );
};
